import { CollectionHero, HubTiles } from "@/components/CollectionHero";
import { VENEERS_HUB } from "@/lib/timber";

export default function VeneersHub() {
  return (
    <div data-testid="veneers-hub">
      <CollectionHero
        crumbs={[
          { label: "Our Collection", to: "/collection" },
          { label: "Timber Collection", to: "/collections/timber" },
          { label: "Veneers" },
        ]}
        eyebrow={VENEERS_HUB.eyebrow}
        title={VENEERS_HUB.title}
        intro={VENEERS_HUB.intro}
        hero={VENEERS_HUB.hero}
      />
      <HubTiles items={VENEERS_HUB.categories} columns="sm:grid-cols-2 lg:grid-cols-4" />
    </div>
  );
}
